import { STATS } from "../mock";

export default function Stats() {
  return (
    <section className="relative bg-[#0d1a2e] text-white overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />
      <div className="absolute -top-32 right-0 w-[40rem] h-[40rem] glow-emerald pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
            By the numbers
          </div>
          <h2 className="mt-4 text-[36px] lg:text-[56px] font-extrabold leading-[1.05] tracking-[-0.025em]">
            Built on results,{" "}
            <span className="text-[#16d196]">not promises.</span>
          </h2>
        </div>

        <div className="mt-12 lg:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="bg-white/[0.04] border border-white/10 rounded-2xl p-6 lg:p-7"
            >
              <div className="text-[42px] lg:text-[54px] font-extrabold leading-none tracking-[-0.03em]">
                {s.value}
              </div>
              <div className="mt-4 text-[14.5px] font-bold text-[#16d196]">{s.label}</div>
              <div className="text-[12.5px] text-white/55 mt-1">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
